import React from 'react';
import { useData } from '../../context/DataContext';
import { Select } from '../ui/Select';
interface CustomerSelectProps {
  value: string;
  onChange: (customerId: string) => void;
  error?: string;
}
export function CustomerSelect({
  value,
  onChange,
  error
}: CustomerSelectProps) {
  const {
    filteredCustomers
  } = useData();
  const options = filteredCustomers.map(customer => ({
    value: customer.id,
    label: customer.name
  }));
  return <Select label="Customer" options={options} value={value} onChange={e => onChange(e.target.value)} placeholder="Select a customer" error={error} data-id="element-25" />;
}